import { Modal } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { Button } from "../../components";
import { FormInput } from "../../components/forms";
import StandardParagraphTypeSelect from "../../components/forms/selects/StandardParagraphTypeSelect";
import useCreateStandardParagraph from "./hooks/useCreateStandardParagraph";
import ThemedModal from "../../components/utilities/ThemedModal";

const CreateStandardParagraphModal = ({ show, onHide }) => {
    const { onSubmit, control, setValue, clearErrors, formState: { errors }, onClose } = useCreateStandardParagraph(onHide);

    return <Modal show={show} backdrop="static" size="md">
        <ThemedModal.Header>
            <Modal.Title>Create Standard Paragraph</Modal.Title>
        </ThemedModal.Header>
        <form onSubmit={onSubmit}>
            <Modal.Body className="d-flex row gy-2">
                <Controller
                    control={control}
                    name={'typeId'}
                    rules={{ required: "Please select a type of paragraph to create" }}
                    render={({ field: { ref, name, value, onChange, onBlur, ...rest } }) => (
                        <StandardParagraphTypeSelect
                            label="Select a Paragraph Type:"
                            value={value}
                            setValue={(newValue) => {
                                clearErrors(name);
                                setValue(name, newValue);
                            }}
                            disableAnimations
                            useOnChange
                            errorMessage={errors.typeId?.message}
                            errorAllowRetry={false}
                            {...rest}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={'name'}
                    rules={{ required: "Please enter a name for the new Standard Paragraph" }}
                    render={({ field: { ref, name, value, onChange, onBlur, ...rest } }) => (
                        <FormInput
                            label="Enter a Name for the new Paragraph:"
                            value={value}
                            onChange={(e) => {
                                clearErrors(name);
                                setValue(name, e.target.value);
                            }}
                            disableAnimations
                            errorMessage={errors.name?.message}
                            errorAllowRetry={false}
                            {...rest}
                        />
                    )}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type='submit'>Create</Button>
                <Button variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </form>
    </Modal>
}

export default CreateStandardParagraphModal;